var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fdc134"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.91,135.44h97.52c59.32,0,104.28,31.88,121.01,78.28h30.38v28.04h-23.98c.47,4.43,.71,8.94,.71,13.53v.69c0,5.16-.3,10.24-.9,15.21h24.17v28.04h-30.96c-17.17,45.75-61.78,77.33-120.43,77.33h-97.52v-77.33h-33.89v-28.04h33.89v-29.43h-33.89v-28.04h33.89v-78.28Zm27.26,163.79v52.17h70.26c43.35,0,75.56-20.9,90.56-52.17H186.17Zm169.17-28.04H186.17v-29.43h169.21c.63,4.63,.95,9.38,.95,14.22v.69c0,4.95-.34,9.8-.99,14.52Zm-98.91-110.64c43.55,0,75.86,21.45,90.76,53.16H186.17v-53.16h70.26Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.4e9579ba7e3e2f554b4634c454f633e6.svg";
export { ForwardRef as ReactComponent };